import { render, staticRenderFns } from "./edit_datos.vue?vue&type=template&id=450b621a&scoped=true"
import script from "./edit_datos.vue?vue&type=script&lang=js"
export * from "./edit_datos.vue?vue&type=script&lang=js"
import style0 from "./edit_datos.vue?vue&type=style&index=0&id=450b621a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450b621a",
  null
  
)

export default component.exports